"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import {
  PRODUCTS_BINDING,
  PRODUCTS_BINDING_INPUT,
} from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const imageNavLinksListInputs = [] as const satisfies Inputs;

export const ImageNavLinksListComponent: RegisteredComponent = {
  name: "ImageNavLinksList",
  canHaveChildren: true,
  inputs: [PRODUCTS_BINDING_INPUT],
  component: dynamic(async () =>
    withValidation(
      imageNavLinksListInputs,
      (await import("./ImageNavLinksList")).ImageNavLinksList,
      "ImageNavLinksList"
    )
  ),
  defaults: {
    bindings: PRODUCTS_BINDING,
  },
};
